<template>
  <b-sidebar
    id="sidebar-right"
    z-index="51001"
    title="Edit question"
    right
    shadow
    :visible="active"
    backdrop
    no-header
    sidebar-class="sidebar-lg"
    header-class="header-dark"
    bg-variant="white"
    width="420px"
    @change="val => $emit('update:active', val)"
    @hidden="clearForm"
  >
    <!-- @hidden="clearForm" -->
    <!--<template #footer="{ hide }">
      <div class="d-flex header-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto">Footer</strong>
        <b-button size="sm" @click="hide">Close</b-button>
      </div>
    </template>-->

    <template #default="{ hide }" v-if="question">
      <!-- Header -->
      <div
        class="header-dark d-flex justify-content-between align-items-center content-sidebar-header px-4 py-3"
      >
        <!--  <b-button size="sm" variant="outline-success rounded-lg">
          {{ "Completed" }}
        </b-button> -->
        <vs-dropdown class="cursor-pointer flex" vs-custom-content>
          <feather-icon
            :icon="iconMap[question.type].icon"
            class="p-2 inline-flex rounded-lg bg-white border border-warning shadow-sm"
            svgClasses="h-5 w-5"
          />

          <vs-dropdown-menu style="z-index: 200001">
            <vs-dropdown-item
              :disabled="true"
              @click.stop="changeType(iconKey)"
              class="px-0 py-2"
              v-for="(iconKey, index) in Object.keys(iconMap)"
              :key="index"
            >
              <feather-icon
                :icon="iconMap[iconKey].icon"
                class="p-2 inline-flex rounded-lg bg-white border border-light-grey shadow-sm"
                :class="{
                  'border-warning text-warning stroke-warning': iconKey === question.type,
                }"
                svgClasses="h-5 w-5"
              />
              <span class="ml-3">{{ iconMap[iconKey].name }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <!--   <h5 v-else class="mb-0">Add Task</h5> -->
        <div>
          <feather-icon
            icon="TrashIcon"
            class="cursor-pointer mr-2"
            svgClasses="h-5 w-5 stroke-2"
            @click="
              $emit('delete:question', question);
              hide();
            "
          />
          <!--<feather-icon
            class="ml-3 cursor-pointer"
            icon="InfoIcon"
            svgClasses="h-5 w-5 stroke-2"
            
          />-->
          <feather-icon
            class="ml-3 cursor-pointer"
            icon="XIcon"
            svgClasses="h-5 w-5 stroke-2"
            @click="hide"
          />
        </div>
      </div>

      <div class="px-4">
        <!-- Form start -->
        <div>
          <form>
            <div class="vx-row">
              <div class="vx-col w-full">
                <label class="mt-4 form-label">Question type</label>
                <p>{{ iconMap[question.type].name }}</p>
                <label class="form-label">Title</label>
                <vs-input
                  :disabled="!isEditable"
                  name="title"
                  v-model="question.title"
                  class="w-full mb-4"
                  placeholder="Title"
                />
                <label class="form-label">Help text <small>(Optional)</small></label>
                <vs-textarea
                  :disabled="!isEditable"
                  rows="5"
                  v-model="question.helpText"
                  placeholder="Help text"
                />

                <label class="form-label">Category</label>
                <vs-select
                  :disabled="!isEditable"
                  class="w-full"
                  v-model="question.category"
                  placeholder="No category"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in availableCategories"
                  />
                </vs-select>

                <vs-row class="flex flex-wrap items-center mt-4">
                  <vs-button
                    class="mr-5 rounded-lg"
                    color="warning"
                    :disabled="!isEditable"
                    @click="
                      $emit('update:question');
                      hide();
                    "
                    >Save</vs-button
                  >
                  <vs-button class="rounded-lg" color="primary" @click="hide">Cancel</vs-button>
                </vs-row>
                <!-- end  -->
              </div>
            </div>
          </form>
        </div>
        <!-- Form end -->
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";
export default {
  components: { vSelect },
  data() {
    return {
      selected: null,
    };
  },
  props: {
    isEditable: {
      type: Boolean,
      default: false,
    },
    availableCategories: {
      type: [],
      default: () => [],
    },
    question: {
      type: Object,
      default: () => ({}),
    },
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: ["update:active", "update:question", "delete:question"],
  computed: {
    ...mapGetters({
      iconMap: "lists/iconMap",
    }),
  },
  methods: {
    changeType(type) {
      this.question.type = type;
    },
    clearForm() {
      console.log("Clear form");
    },
  },
  async mounted() {},
};
</script>


<style scoped lang="css" src="bootstrap/dist/css/bootstrap.min.css"></style>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.22.0/bootstrap-vue.min.css";

.header-dark {
  background-color: #f6f6f6;
}
.form-label {
  color: #5e5873;
  font-size: 0.857rem;
}
</style>
